export const languageElements = {
  items: {
    "field-refNo": {
      hu: "AWB No./BL No/Container No.:",
      de: "AWB No./BL No/Container No.:",
      en: "AWB No./BL No/Container No.:",
    },

    "btn-search": {
      hu: "Keresés",
      de: "Suchen",
      en: "Search",
    },

    "validation-required": {
      hu: "Kérem adja meg a szállítási azonosítót",
      de: "Bitte geben Sie die Versand-ID ein",
      en: "Please enter the shipping ID",
    },
  },
};
